import ProductTraceabilityPanel from "./productTraceabilityPanel.container"

export default ProductTraceabilityPanel
